import { Link, useNavigate } from 'react-router-dom'

import { t } from 'lib/i18n'

import { SystemMessage } from './SystemMessage'

export const NotFoundPage = () => {
  const navigate = useNavigate()

  return (
    <SystemMessage
      icon="search"
      code="404"
      title={t('الصفحة غير موجودة', 'Page not found')}
      description={t('الرابط الذي فتحته غير صحيح أو تم نقل الصفحة.', 'The link you opened is wrong, or the page has moved.')}
      actions={
        <Link to="/" className="btn btn--primary">
          {t('العودة إلى المشاريع', 'Back to projects')}
        </Link>
      }
      footer={
        <button type="button" className="link-button" onClick={() => navigate(-1)}>
          {t('الرجوع للصفحة السابقة', 'Back to the previous page')}
        </button>
      }
    />
  )
}
